import type { Theme } from '@mui/material/styles/createTheme'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import MuiButton from '@mui/material/Button'
import { ButtonProps } from './Button.types'

type CssProps = ButtonProps & { theme?: Theme }

export const sizeStyles = ({ size }: Pick<CssProps, 'size'>) => {
  switch (size) {
    case 'xSmall':
      return css`
        height: 20px;
        padding: 0 16px;
        font-size: 12px;
      `
    case 'small':
      return css`
        height: 28px;
        padding: 0 16px;
        font-size: 14px;
      `
    case 'large':
      return css`
        height: 44px;
        padding: 0 16px;
        font-size: 16px;
      `
    case 'xLarge':
      return css`
        height: 52px;
        padding: 0 16px;
        font-size: 16px;
      `
    case 'medium':
    default:
      return css`
        height: 36px;
        padding: 0 16px;
        font-size: 14px;
      `
  }
}

const variantStyles = ({ theme, variant }: Pick<CssProps, 'theme' | 'variant'>) => {
  switch (variant) {
    case 'outlined':
      return css`
        position: relative;
        background-color: ${theme?.palette.common.white};
        ::before {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          content: '';
          color: inherit;
          background-color: currentcolor;
          opacity: 0;
        }
        &:hover {
          background-color: ${theme?.palette.common.white};
          ::before {
            opacity: 0.04;
          }
        }
      `
    default:
      return null
  }
}

const disabledStyles = ({ theme, variant }: Pick<CssProps, 'theme' | 'variant'>) => {
  switch (variant) {
    case 'text':
      return css`
        color: rgba(224, 224, 224, 50%);
        background-color: transparent;
      `
    default:
      return css`
        color: rgba(0, 0, 0, 26%);
        background-color: ${theme?.palette.common.gray[300]};
        border: 0 none;
      `
  }
}

export const Button = styled(MuiButton)`
  ${sizeStyles};
  ${variantStyles};
  &.Mui-disabled {
    ${disabledStyles};
  }
  letter-spacing: normal;
  line-height: normal;
  white-space: nowrap;
`
